module.exports = __webpack_public_path__ + "static/media/attachment-red-icon.3f486ef7.svg";